var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefiLlamaBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 136,
    viewBox: "0 0 110 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_78835)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1617_78835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.176 136H40.1729C37.316 136 35 133.684 35 130.827V55.1729C35 52.316 37.316 50 40.1729 50H66.1318C75.265 50 83.1086 51.7217 89.6626 55.165C96.2167 58.5804 101.238 63.4935 104.728 69.9043C108.248 76.2871 110.008 83.9437 110.008 92.874C110.008 101.832 108.232 109.531 104.682 115.97C101.163 122.409 96.065 127.364 89.3895 130.835C82.7141 134.278 74.6429 136 65.176 136Z",
    fill: "#CDFEB0",
    fillOpacity: 0.11,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.176 136H40.1729C37.316 136 35 133.684 35 130.827V55.1729C35 52.316 37.316 50 40.1729 50H66.1318C75.265 50 83.1086 51.7217 89.6626 55.165C96.2167 58.5804 101.238 63.4935 104.728 69.9043C108.248 76.2871 110.008 83.9437 110.008 92.874C110.008 101.832 108.232 109.531 104.682 115.97C101.163 122.409 96.065 127.364 89.3895 130.835C82.7141 134.278 74.6429 136 65.176 136Z",
    fill: "url(#paint2_linear_1617_78835)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1617_78835",
    x: 29.8448,
    y: 44.8448,
    width: 85.3183,
    height: 96.3105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.57761
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1617_78835"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.429602,
    dy: -0.429602
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1617_78835",
    result: "effect2_dropShadow_1617_78835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1617_78835",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1617_78835",
    x1: 87.5546,
    y1: 77.52,
    x2: 47.0958,
    y2: 101.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FCA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_78835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiLlamaBlur);
export default __webpack_public_path__ + "static/media/defi-llama-blur.348a6b5add4c1c4a83d9edca8739b32b.svg";
export { ForwardRef as ReactComponent };